import React, { useState } from "react";
import { Grid, Typography, Box, Slider, Button } from "@mui/material";
import { styled } from "@mui/material";

import ButtonComponent from "../../components/saving-league/buttonBottom";
const maintainshopping = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/shopping-streak.png";
const thumbimg = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/thumbimg.png";
// import maintainshoppingimg from "../../images/diwali/maintainshoppingimg.png";
const point200 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/point200.png";
const point200active = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/point200active.png";
const point300 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/point300.png";
const point300active = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/point300active.png";
const point500 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/point500.png";
const point500active = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/500active.png";

// import point500active from "../../images/diwali/point500active.png";
const win200 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/winnig.png";
const win300 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/win300.png";
const win500 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/win500.png";

const CustomSlider = styled(Slider)(({ theme }) => ({
  "& .MuiSlider-mark.MuiSlider-markActive:first-child": {
    background: "transparent",
  },
}));

const images = {
  2: point200active,
  3: point300active,
  5: point500active,
};

const marks = [
  { value: 0,  },
  { value: 2,},
  { value: 3,  },
  { value: 5, },
];
export default function MaintainShopping() {
  const [sliderValue, setSliderValue] = useState(localStorage.getItem("savings_current_streak") || 0);

  const handleSliderChange = (event, newValue) => {
    setSliderValue(newValue);
  };

  return (
    <Grid container sx={{ background: "#fff" }}>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} sx={{  background: '#1F162E', }}>
        <Grid
          sx={{
            width: "100%",
          }}
        >
          <Grid pb={2}>
            <img src="https://d2sriifpjiqv0p.cloudfront.net/diwali/streak.png" style={{ width: "100%" }} />
          </Grid>

          <Grid pt={2} px={3}>
            <Typography sx={{fontWeight:'700', fontSize:'1rem',fontFamily:'metropolis', textAlign:'center', lineHeight:'140%'}}>Maintain Shopping Streak</Typography>
         <Typography sx={{fontWeight:'500', fontSize:'12px',fontFamily:'metropolis', textAlign:'center', lineHeight:'140%'}} mt={1}>Shop daily for 2 or more days to build your streak and get up to 1000 points.</Typography>
          </Grid>

          <Grid mt={2}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                padding: "0 0 16px",
                gap:"0",
                // maxWidth:"350px",
                margin:"0 auto"
              }}
            >
              <Box
              sx={{
                position:"relative",
                left:"30px",
                width:"33.3%",
                minWidth:"138px",
              }}
              >
                <img
                  src={sliderValue >= 2 ? images[2] : point200}
                  style={{ width: "100%" }}
                />

                <Typography
                  sx={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Metropolis",
                    fontSize: "10px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "10px",
                    position: "relative",
                    top: "-10px",
                  }}
                >
                  Day 2
                </Typography>
              </Box>
              <Box
              sx={{
                position:"relative",
                width:"33.3%",
                minWidth:"138px",
              }}
             
              >
                <img
                  src={sliderValue >= 3 ? images[3] : point300}
                  style={{ width: "100%" }}
                />
                <Typography
                  sx={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Metropolis",
                    fontSize: "10px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "10px",
                    position: "relative",
                    top: "-10px",
                  }}
                >
                  Day 3
                </Typography>
              </Box>
              <Box
              sx={{
                position:"relative",
                right:"30px",
                width:"33.3%",
                minWidth:"138px",
              }}
              >
                <img
                  src={sliderValue >= 5 ? images[5] : point500}
                  style={{ width: "100%" }}
                />
                <Typography
                  sx={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Metropolis",
                    fontSize: "10px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "10px",
                    position: "relative",
                    top: "-10px",
                  }}
                >
                  Day 5
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                padding: "0 40px",
                position: "relative",
              }}
            >
       <CustomSlider
    aria-label="Temperature"
    defaultValue={0}
    value={sliderValue}
    onChange={handleSliderChange}
    valueLabelDisplay="on"
    valueLabelFormat={(value) => (value === 0 ? "No streak yet" : `You are at day ${value}`)}
    step={1}
    marks={marks}
    disabled
    min={0}
    max={5}
    sx={{
        color: "#E85F34", // Change the color here
        padding: "4px !important",
        boxShadow: "0px 0px 0px",
        borderRadius: "20px",
        zIndex: "222",
        fontFamily:'Metropolis',
        position: "relative",
        height: 6,
        '& .MuiSlider-valueLabel': {
            bgcolor: 'transparent', // Background color of the label
            color: 'white', // Text color of the label
            borderRadius: 1, // Rounded corners
            padding: '4px 8px', // Padding around the label
            fontSize: "8px",
            position: "absolute",
            top: "calc(100% + 16px)", // Adjust to place tooltip below
            left: "-65%",
            transform: "translateX(-50%)", // Center tooltip horizontally
        },
        '& .MuiTooltip-tooltip': {
          
          bgcolor: 'transparent', // Background color of the label
          color: 'white', // Text color of the label
          borderRadius: 1, // Rounded corners
          padding: '4px 8px', // Padding around the label
          fontSize: "8px",
          position: "absolute",
           top: "calc(100% + 16px)",
          left: "-35%",
          transform: "translateX(-50%)", // Center tooltip horizontally
        },
        '&.Mui-disabled': {
            color: '#E85F34', // Custom color for disabled state
        },
        "& .MuiSlider-thumb": {
            height: 26,
            width: 37,
            background: `url(${thumbimg})`, // Change thumb image
            "&:focus, &:hover, &.Mui-active": {
                boxShadow: "inherit",
            },
            ":before": {
                boxShadow: "0px 0px 0px",
            },
                        "&::after": {
                          content: `"${sliderValue}"`,
                          position: "absolute",
                          top: "5px",
                          color: "#FFF",
                          // left: "0%",
                          left: sliderValue <= 6 ? "70%" : "0%",
                          fontSize: "12px", // Adjust size
                          fontWeight: "bold",
                          transform: "none"

                        },
        },
        "& .MuiSlider-track": {
            height: 10, // Change track height
        },
        "& .MuiSlider-rail": {
            height: 10, // Change rail height
            backgroundColor: "#36276A", // Rail color
            opacity: "1",
        },
        "& .MuiSlider-mark": {
            backgroundColor: "#36276A", // Mark color
            height: 16, // Mark height
            width: 2, // Mark width
            borderRadius: "20px",
            '&.MuiSlider-markActive': {
                backgroundColor: '#E85F34', // Active mark color
            },
        },
        "& .MuiSlider-markLabel": {
            color: "#fff",
            fontSize: "8px",
            top: "24px !important",
        },
        "& .MuiSlider-markLabel:first-of-type": {
            marginLeft: "8px",
        },
        "& .MuiSlider-markLabel:last-of-type": {
            marginRight: "8px",
        },
    }}
/>

            </Box>

            <Box>
              <Typography
                sx={{
                  color: "rgba(255, 255, 255, 0.50)",
                  textAlign: "center",
                  fontFamily: "Metropolis",
                  fontSize: "10px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "140%",
                  paddingBottom: "40px",
                  paddingTop: "32px",
                }}
              >
                *Last updated on {localStorage.getItem('formated_date')}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid style={{ marginBottom: "129px", background:'transparent'}} sx={12}>
          <img src={win200} style={{ width: "100%" }} />

      
     

        </Grid>
        <a href='cashkaro://home'><ButtonComponent title="Start Your Streak"/></a>
        
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>{" "}
    </Grid>
  );
}
